// This hook returns an object that toggles on and off
// the analytics tabs on the homepage.
import { useRouteAccess } from 'src/routes/routeAccess';

// the analytics tabs on the homepage.
export function useAnalyticsAccess() {
  const routeAccess = useRouteAccess();
  return {
    CLIENT: true,
    CLIENT_ACTIVATION: true,
    SUBSCRIPTION: routeAccess.allowSubscriptionPage,

    // TODO: Bring back this check, I had a hard time getting the USD
    //       payout account check working.
    // SUBSCRIPTION:
    //   routeAccess.allowSubscriptionPage &&
    //   accountInfo?.default_currency === 'USD',
  } as const;
}
